class ProductGrid extends HTMLElement {
    constructor() {
        super();

        this.button = this.querySelector('.js-load-more-btn')
        this.btnText = this.button.querySelector('.st-load-more_text')
        this.btnSpinner = this.button.querySelector('.st-load-more_spinner')

        this.loadMoreBtn = this.querySelector('.js-back-top-btn')

        this.loadMoreBtn.addEventListener('click', this.backTopClick.bind(this));
        this.button.addEventListener('click', this.loadMoreClick.bind(this));

        this.autoLoadProducts(this.button)
    }

    loadMoreClick() {
        this.getMoreProducts()
    }

    getMoreProducts() {
        const wrapper = this.querySelector('#st-product-grid')
        const pages = parseInt(wrapper.dataset.pages)
        const productGrids = wrapper.querySelectorAll(".js-product-grid")
        const url = productGrids[productGrids.length - 1].dataset.nextUrl
        const length = productGrids.length + 1
       
        if (length > pages) {
            this.button.classList.add('hide')
            this.loadMoreBtn.classList.remove('hide')
        }

        if (length <= pages) {
            this.btnSpinner.classList.add('show')
            this.btnText.classList.add('hide')

            fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const parser = new DOMParser();
                const fetchedDocument = parser.parseFromString(responseText, "text/html");
                const products = fetchedDocument.documentElement.querySelector(".js-product-grid");
                const gridItems = products.querySelectorAll('.js-grid-item')

                gridItems.forEach(item => {
                    item.classList.add('aos-animate')

                    const imageElements = item.querySelectorAll('image-element');
                    imageElements.forEach(image => {
                        image.classList.add('aos-init', 'aos-animate');
                    });
                })

                wrapper.append(products)
                this.btnSpinner.classList.remove('show')
                this.btnText.classList.remove('hide')
            })   
        } 
    }


    autoLoadProducts(target) {
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                this.getMoreProducts()
            }
        },
        {
            rootMargin: "200px",
        }
        )

        observer.observe(target)
    }

    backTopClick(e) {
        e.preventDefault()
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }
}
window.customElements.define('product-grid', ProductGrid);